var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let MenubarSpeakIcon = class MenubarSpeakIcon extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get iconColor() {
        if (this.props.app.user.userStore.isSpeakerMuted) {
            return '#666666';
        }
        if (this.props.app.speak.speakInfo.isSystemCurrentlySpeaking) {
            return 'green';
        }
        return 'rgb(66, 139, 202)';
    }
    get icon() {
        if (this.props.app.user && this.props.app.user.userStore.isSpeakerMuted) {
            return 'fas fa-volume-mute';
        }
        return 'fas fa-volume-up';
    }
    get tooltip() {
        if (this.props.app.user && this.props.app.user.userStore.isSpeakerMuted) {
            return 'Sprachausgabe anschalten';
        }
        return 'Sprachausgabe ausschalten';
    }
    render() {
        return (React.createElement(AvailableTooltip, { title: this.tooltip, placement: "bottom" },
            React.createElement("i", { className: this.icon, style: { color: this.iconColor, cursor: 'pointer' }, onClick: this.handleClick })));
    }
    handleClick() {
        this.props.app.user.userStore.isSpeakerMuted = !this.props.app.user.userStore.isSpeakerMuted;
    }
};
__decorate([
    action.bound
], MenubarSpeakIcon.prototype, "handleClick", null);
MenubarSpeakIcon = __decorate([
    observer
], MenubarSpeakIcon);
export { MenubarSpeakIcon };
